if (!customElements.get('metafield-file-parse')) {
	customElements.define('metafield-file-parse', class MetafieldFileParse extends HTMLElement {
    constructor() {
			super();
			this.fileUrl = this.dataset.fileUrl;
      this.gridTable = this.querySelector('.grid-blocks');
		}

    async parseFile() {
      try {
        const response = await fetch(this.fileUrl);
        const csvText = await response.text();
        const result = await Papa.parse(csvText, { header: true });
         
        const gridTableHeadings = result.meta.fields;
        this.gridTable.style.gridTemplateColumns = `repeat(${result.meta.fields.length}, 1fr)`;
        
        gridTableHeadings.map(item => {
          const headingElem = document.createElement('div');
          headingElem.classList.add('border');
          headingElem.classList.add('grid-heading');
          headingElem.innerText = item;
          this.gridTable.append(headingElem);
        });
        
        result.data.map(item => {
          const gridItem = document.createElement("div");
          gridItem.classList.add("grid-item");
          gridItem.style.gridTemplateColumns = `repeat(${result.meta.fields.length}, 1fr)`;
          gridItem.style.gridColumn = `1/${result.meta.fields.length + 1}`;
          
          for (const key in item) {
            const gridInnerItem = document.createElement("div");
            gridInnerItem.classList.add("border")
            gridInnerItem.innerText = item[key];
            gridItem.append(gridInnerItem);
          }
          
          this.gridTable.append(gridItem);  
        })
      } catch (error) {
        console.log(error);
      } 
    }

    connectedCallback() {
      this.parseFile();
    }

  });
}